import { DataSourceFactory } from 'app/components';

interface IFoundationData {
  name: string;
  location: string;
  ein: string;
  totalAssets: number;
}

const filterBody = { action: 'getByAssetLevelAndState', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } };

const FoundationMarkSources = DataSourceFactory.create<IFoundationData>({
  transport: {
    read: {
      url: 'https://kbqk6mximj.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests',
      insertBodyBeforeRequest: () => JSON.stringify(filterBody),
      request: { method: 'POST' },
    },
  },
});

const filterAndSyncFoundationMarkSources = (assetLevel: number, state: string) => {
  filterBody.request.assetLevel = assetLevel;
  filterBody.request.state = state;

  FoundationMarkSources.sync();
};

export { filterAndSyncFoundationMarkSources, FoundationMarkSources, IFoundationData };



// WEBPACK FOOTER //
// ./src/app/containers/Resources/DataSources.ts